"use client";

import dynamic from "next/dynamic";
import { LogoFallback } from "@/components/game/LogoFallback";

const VoxelGame = dynamic(() => import("@/components/game/VoxelGame"), {
  ssr: false,
  loading: () => <LogoFallback />,
});

export default function Home() {
  return <VoxelGame />;
}
